export const ToggleOnlineConference = (payload) => ({
  type: "TOGGLEONLINECONFERENCE",
  payload,
});

export const ZoomWindowOpen = (payload) => ({
  type: "ZOOMWINDOWOPEN",
  payload,
});
